/* Client-side product filtering shared by the "Landing · Filter + Products"
   panel and the sub-tab pills on "Landing · Product Row".
   Groups combine with AND; options inside a group are single-select. */
(function () {
  var FIELD_ATTR = {
    tag: 'lpTags',
    type: 'lpType',
    vendor: 'lpVendor',
    title: 'lpTitle',
    sku: 'lpSku'
  };

  /* Tags, type and vendor are emitted comma-delimited so "steel" cannot match
     "stainless-steel". Title and SKU stay loose substring matches on purpose. */
  var DELIMITED = { tag: true, type: true, vendor: true };

  /* A dropdown holding a selection is styled like an active pill. */
  function paintSelect(sel) {
    sel.classList.toggle('lp-select--active', sel.value !== '');
  }

  function setupPanel(panel) {
    var section = panel.closest('.shopify-section') || document;
    var carousel = section.querySelector('[data-lp-carousel]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-lp-slide]'));
    var empty = section.querySelector('[data-lp-no-match]');
    if (!slides.length) return;

    var groups = Array.prototype.slice.call(panel.querySelectorAll('[data-lp-group]'));
    if (panel.hasAttribute('data-lp-group')) groups.push(panel);
    if (!groups.length) return;

    var active = {};

    function matches(slide) {
      for (var groupId in active) {
        var filter = active[groupId];
        if (!filter || !filter.value) continue;

        var haystack = slide.dataset[FIELD_ATTR[filter.field] || 'lpTags'] || '';

        /* A value may join several tags with "+", all of which must match. That
           is what lets two dropdowns offer the same mount ("Tractor") and still
           return different products, by scoping each to its own category. */
        var parts = filter.value.split('+');
        for (var i = 0; i < parts.length; i++) {
          var part = parts[i].trim();
          if (!part) continue;
          var needle = DELIMITED[filter.field] ? ',' + part + ',' : part;
          if (haystack.indexOf(needle) === -1) return false;
        }
      }
      return true;
    }

    function apply() {
      var shown = 0;

      slides.forEach(function (slide) {
        var visible = matches(slide);
        slide.hidden = !visible;
        if (visible) shown++;
      });

      if (empty) empty.hidden = shown > 0;

      var swiper = carousel && carousel.swiper;
      if (swiper) {
        swiper.update();
        swiper.slideTo(0, 0);
        if (swiper.pagination && swiper.pagination.el) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      }
    }

    function select(groupEl, value) {
      active[groupEl.dataset.lpGroup] = {
        field: groupEl.dataset.lpMatch || 'tag',
        value: value
      };

      groupEl.querySelectorAll('[data-lp-value]').forEach(function (option) {
        option.setAttribute('aria-pressed', option.dataset.lpValue === value ? 'true' : 'false');
      });

      /* A dropdown that shares this key only mirrors the value when it actually
         offers it; otherwise it falls back to its placeholder rather than
         going blank, so picking a pill visibly clears the dropdown beside it. */
      groupEl.querySelectorAll('select').forEach(function (sel) {
        var offersValue = Array.prototype.some.call(sel.options, function (option) {
          return option.value === value;
        });
        sel.value = offersValue ? value : '';
        paintSelect(sel);
      });

      apply();
    }

    groups.forEach(function (groupEl) {
      /* Seed from whichever option the section rendered as pressed, so a group
         with no "All" starts genuinely filtered rather than just looking it. */
      var preset = groupEl.querySelector('[data-lp-value][aria-pressed="true"]');
      if (preset) {
        active[groupEl.dataset.lpGroup] = {
          field: groupEl.dataset.lpMatch || 'tag',
          value: preset.dataset.lpValue || ''
        };
      }

      groupEl.addEventListener('click', function (event) {
        var option = event.target.closest('[data-lp-value]');
        if (!option || !groupEl.contains(option)) return;
        select(groupEl, option.dataset.lpValue || '');
      });

      groupEl.querySelectorAll('select').forEach(paintSelect);

      groupEl.addEventListener('change', function (event) {
        if (event.target.tagName !== 'SELECT') return;
        select(groupEl, event.target.value || '');
      });
    });

    apply();
  }

  function init() {
    document.querySelectorAll('[data-lp-filter-panel]:not([data-lp-ready])').forEach(function (panel) {
      panel.dataset.lpReady = 'true';
      setupPanel(panel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
